import type { OrderDTO } from '@wf/shared'

const PRIO_ORDER: Record<string, number> = { hoch: 0, mittel: 1, niedrig: 2 }

/** Die mir zugewiesenen, noch offenen Aufträge (nicht fertig/abgeholt), nach Priorität (hoch zuerst). */
export function selectMyOpenJobs<T extends OrderDTO>(orders: readonly T[], userId: number): T[] {
  return orders
    .filter((order) => order.mechanicId === userId && order.status !== 'fertig' && order.status !== 'abgeholt')
    .sort((a, b) => (PRIO_ORDER[a.prio] ?? 1) - (PRIO_ORDER[b.prio] ?? 1))
}
